import { render, staticRenderFns } from "./ExchangeRateDialog.vue?vue&type=template&id=36297467"
import script from "./ExchangeRateDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeRateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports